<template>
    <b-navbar toggleable="xl" type="light">
        <b-navbar-brand :href="kareliasHost + '/archiki'">
            <img class="logo order-1" src="@/assets/logos/karelia_logo_transparent.png" alt="logo">
        </b-navbar-brand>
        <b-navbar-nav class="order-xl-3 ml-auto">
            <div class="lang-list">
                <b-nav-item
                    class="lang el"
                    :class="{'current-lang': $root.$i18n.locale ==='el'}"
                    @click="changeLang('el')"
                >
                    GR
                </b-nav-item>
                <b-nav-item
                    class="lang en"
                    :class="{'current-lang': $root.$i18n.locale ==='en'}"
                    @click="changeLang('en')"
                >
                    EN
                </b-nav-item>
                <b-nav-item class="map" :href="kareliasHost + '/sitemap'">
                    <img src="@/assets/icons/sitemap.png" alt="map">
                </b-nav-item>
                <b-nav-item class="search" :href="kareliasHost + '/search'">
                    <img src="@/assets/icons/search.png" alt="search">
                </b-nav-item>
            </div>
        </b-navbar-nav>
        <b-navbar-toggle target="nav-text-collapse" class="toggle-btn">
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
        </b-navbar-toggle>
        <b-collapse id="nav-text-collapse" is-nav>
            <b-navbar-nav class="menu">
                <b-nav-item v-for="(item, i) in headerItems" :key="i" class="menu-item" :href="replaceHostOnURL(item.url, config.kareliaHost)">
                    {{ item.title }}
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<script>
    import menuService from '@/services/menu-service'
    import config from '@/mixins/config'

    export default {
        name: 'Navbar',
        mixins: [config],
        data() {
            return {
                menu: {}
            }
        },
        computed: {
            headerItems() {
                const langUpperCase = this.$root.$i18n.locale.toUpperCase()
                return this.menu && this.menu[langUpperCase] && this.menu[langUpperCase].Header
            },
            kareliasHost() {
                if (this.$root.$i18n.locale === 'en') {
                    return this.config.kareliaHost + '/en'
                }
                return this.config.kareliaHost
            }
        },
        created() {
            this.fetchMenu()
        },
        methods: {
            fetchMenu() {
                menuService.fetchMenu()
                    .then(data => {
                        this.menu = data
                    })
            },
            changeLang(lang){
                localStorage.setItem('lang', lang)
                this.$root.$i18n.locale = lang
            },
            replaceHostOnURL(url, host){
                let urlWithoutProtocol = url.replace('https://', '')
                urlWithoutProtocol = urlWithoutProtocol.replace('http://', '')
                const oldHost = urlWithoutProtocol.split('/')[0]
                return urlWithoutProtocol.replace(oldHost, host)
            }
        }
    }
</script>

<style scoped>
.navbar {
    font-family: 'Roboto', sans-serif;
    font-size: 17px;
    font-weight: 400;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 4px solid #2288c0;
    padding: 0;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.navbar-brand {
    width: 110px;
    height: 56px;
    padding: 10px;
    margin: 0 10px !important;
}

.logo {
    width: 90px;
    height: 35.36px;
}

.search img {
    width: 18px;
    height: 24.75px;
}

.search {
    margin-left: 10px;
    display: grid;
    place-items: center;
}

.nav-item.search .nav-link {
    padding: 0;
}

.nav-item.lang .nav-link {
    display: inline-block;
    padding: 10px 0;
}

.nav-item.current-lang .nav-link {
    color: #3897d0;
}

.nav-item.lang .nav-link:hover {
    color: #3897d0;
}

.nav-item.lang .nav-link:focus {
    color: #3897d0;
}

.nav-item.lang.el .nav-link {
    width: 22.05px;
    min-height: 20px;
}

.nav-item.lang.en .nav-link {
    width: 21.78px;
    min-height: 20px;
    margin-left: 5px;
}

.nav-item.menu-item .nav-link:hover {
    color: #6ec6fd;
}

.lang-list {
    display: flex;
}

.navbar-nav.menu {
    padding: 10px 0;
    background-color: #0089c2;
}

.nav-item.menu-item a {
    font-size: 13px;
    color: #fff;
    padding: 6px 0;
}

.nav-item.menu-item {
    padding: 0 20px;
}

.toggle-btn {
    margin-left: 10px;
    border: none;
}

.navbar-light .navbar-toggler {
    padding: 0 20px 0 15px;
    margin-bottom: 7px;
    display: flex;
    flex-direction: column;
}

.navbar-light .navbar-toggler .navbar-toggler-icon {
    width: 24px;
    height: 3px;
    background-color: #0089c2;
    display: block;
    cursor: pointer;
    background-image: none;
    margin-top: 4px;
}

@media screen and (max-width: 1200px) {
    .map {
        display: none;
    }
}

@media screen and (min-width: 481px) {
    .navbar {
        margin-left: 0;
        margin-right: 0;
        border-top: 8px solid #2288c0;
    }

    .logo {
        width: 140px;
        height: 55px;
        display: block;
    }

    .navbar-brand {
        width: 160px;
        height: 76px;
        padding: 10px 40px;
        margin-left: 0 !important;
    }

    .navbar-nav.menu {
        padding: 15px 0;
    }

    .nav-item.menu-item a {
        font-size: 15px;
        padding: 8px 0;
    }

    .nav-item.menu-item {
        padding: 0 40px;
    }

    .search img {
        width: 24px;
        height: 33px;
    }

    .toggle-btn {
        margin-right: 30px;
    }

    .navbar-light .navbar-toggler {
        padding: 0 15px;
    }

    .navbar-light .navbar-toggler .navbar-toggler-icon {
        width: 34px;
        height: 4px;
        margin-top: 6px;
    }
}

@media screen and (min-width: 768px) {
    .logo {
        width: 170px;
        height: 66.8px;
    }

    .navbar-brand {
        width: 200px;
        height: 98px;
        padding: 10px 40px;
        margin-left: 0 !important;
    }
}

@media screen and (min-width: 1200px) {
    .navbar-brand {
        padding: 15px;
        margin: 0 0 0 -15px !important;
    }

    .map img {
        width: 33px;
        height: 33px;
    }

    .nav-item.map .nav-link {
        padding: 0 6px;
        border-right: 1px solid #dadada;
        line-height: 2.8;
    }

    .search {
        margin: 0;
    }

    .nav-item.search .nav-link {
        border: 0;
        padding-right: 10px;
        padding-left: 6px;
        line-height: 3;
    }

    .navbar {
        font-size: 15px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .nav-item.menu-item a {
        font-size: 15px;
        color: #0061a2;
        padding: 10px 0;
    }

    .nav-item.menu-item {
        padding: 0 5px;
    }

    .nav-item.lang .nav-link {
        font-size: 17px;
    }

    .navbar-nav.menu {
        background-color: #fff;
    }

    .nav-item.menu-item .nav-link:hover {
        color: grey;
        border-bottom: 2px solid #3897d0;
    }

    .navbar-light .navbar-toggler {
        display: none;
    }
}

@media screen and (min-width: 1301px) {
    .navbar-brand {
        margin: 0 10px 0 0 !important;
    }

    .nav-item.map .nav-link {
        padding: 0 7px;
    }

    .nav-item.search .nav-link {
        padding-left: 7px;
    }

    .navbar {
        font-size: 16px;
        padding-left: 7px;
        padding-right: 15px;
    }

    .nav-item.menu-item a {
        font-size: 16px;
    }

    .nav-item.menu-item {
        padding: 0 7px;
    }
}

@media screen and (min-width: 1501px) {
    .logo {
        width: 229px;
        height: 90px;
    }

    .navbar-brand {
        width: 259px;
        height: 120px;
        margin-right: 20px !important;
        margin-left: -10px !important;
    }

    .navbar {
        font-size: 17px;
        padding-left: 20px;
        padding-right: 40px;
        border-top: 8px solid #2288c0;
    }

    .nav-item.menu-item a {
        font-size: 17px;
    }

    .nav-item.map .nav-link {
        padding: 0 12px;
        border-right: 1px solid #dadada;
        line-height: 2.5;
    }

    .nav-item.search .nav-link {
        border: 0;
        padding-right: 0;
        padding-left: 12px;
        line-height: 2.5;
    }

    .nav-item.menu-item {
        padding: 0 10px;
    }
}

</style>